import React from 'react'
import Link from 'gatsby-link'
import logo from './logoIFSblackV2.png'
import classnames from 'classnames'
import styles from './index.module.css'


class Footer extends React.Component {
  pop() {
    showMailingPopUp()
  }
  render() {
    return (
      <footer className={styles.footer} >

        <Link to="/">
          <img className={styles.logo} src={logo} alt="brand" />
        </Link>

        <div className={styles.address} >
          <address>
            12 rue de Turgot<br />
            75009 Paris, France
          </address>
          <address>
            31W 34th Street<br />
            NY 10001, USA
          </address>
        </div>

        <div className={styles.socialNetworks} >
          <a href="mailto:info@ifeelsmart.com" className={styles.socialNetwork}>
            <i className={classnames(styles.fa, styles.mail)} ></i>
          </a>

          <a href="https://fr.linkedin.com/company/ifeelsmart" className={styles.socialNetwork}>
            <i className={classnames(styles.fa, styles.first)} ></i>
          </a>

          <a href="https://twitter.com/ifeelsmart" className={styles.socialNetwork}>
            <i className={classnames(styles.fa, styles.second)} ></i>
          </a>

          <a href="https://www.facebook.com/iFeelSmartTV" className={styles.socialNetwork}>
            <i className={classnames(styles.fa, styles.third)} ></i>
          </a>

        </div>
          <button className={styles.newsletter} onClick={this.pop}>newsletter</button>

        <p className={styles.copyright} >&copy; iFeelSmart - 2018/{new Date().getFullYear()}</p>

      </footer>
    )
  }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/index.js